import { InjectionToken } from '../../interfaces/components/dependency-injection/container.interface';

export class Reference<T = unknown> {
  public constructor (private readonly id: InjectionToken<T>) {
  }

  public getId (): InjectionToken<T> {
    return this.id;
  }
}
